import type { Dictionary } from '../types'
import { mergeDictionaries } from '../types'

/**
 * Domain dictionaries are merged here.
 * Each domain file exports `{ tr, en }` nested Dictionary fragments.
 */
import * as auth from './auth'
import * as catalog from './catalog'
import * as commerce from './commerce'
import * as content from './content'
import * as customers from './customers'
import * as settings from './settings'
import * as support from './support'

export const domainsTr: Dictionary = mergeDictionaries(
  auth.tr,
  catalog.tr,
  commerce.tr,
  content.tr,
  customers.tr,
  settings.tr,
  support.tr,
)

export const domainsEn: Dictionary = mergeDictionaries(
  auth.en,
  catalog.en,
  commerce.en,
  content.en,
  customers.en,
  settings.en,
  support.en,
)
